module.exports = __webpack_public_path__ + "fecd8c6c8ba7cb51a01b5be9a9629058.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-29.png
// module id = 2607
// module chunks = 0